<template>
  <div class="modal-share-component" modal-share-component>
    <slot name="share-icon" :handle-share-click="handleShareClick">
      <div class="cursor-pointer share-all-icon d-flex justify-content-center align-items-center" @click="handleShareClick">
        <i class="fa-lg fal fa-share-alt"></i>
      </div>
    </slot>
    <transition enter-active-class="animated faster fadeIn" leave-active-class="animated faster fadeOut">
      <div class="position-fixed share-modal d-flex justify-content-center align-items-center" v-if="shareModalOpened">
        <div class="share-modal__content p-4">
          <div class="pb-3 d-flex justify-content-between">
            <span class="h3">{{ft('globals.share_on')}}</span>
            <span class="cursor-pointer close-icon" @click="shareModalOpened = false">
              <i class="fal fa-times"></i>
            </span>
          </div>
          <div
            class="cursor-pointer d-flex py-3 share-link align-items-center"
            v-for="(provider, index) in shareProviders"
            :key="index"
            @click="startShare(provider)"
          >
            <i class="fa-lg mr-3" :class="providerIcon(provider)"></i>
            <span class="font-weight-bold text-capitalize">{{provider}}</span>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { interactionMixin } from "src/modules/interactions_module.js";
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { VodafoneLab } from "../../modules/vodafone_lab_module.js";

export default {
  mixins: [interactionMixin, fandomBasicMixin],
  props: {
    // Placed temporary as a props, maybe it is better to place it in the globalState
    isIframe: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      shareModalOpened: false,
    };
  },
  methods: {
    handleShareClick() {
      !this.canUseWebShare ? this.shareModalOpened = true : this.startShare('webShare');
    },
    providerIcon(provider) {
      const providerClass =  provider === "facebook" ? "fa-facebook" : Fandom.getProviderIcon(provider);
      const providerWeight = provider === "link" ? "far" : "fab";
      return [providerClass, providerWeight];
    },
    startShare(provider) {
      // We must copy the value to the clipboard here because if we go too deep in the call stack
      // we lose the origin by a click event and so we can't copy anything to the clipboard
      if (["link"].includes(provider)) {
        Fandom.copyToClipboard();
      }

      VodafoneLab.addDigitalDataEvent("social_share", "journey", `:Share:${provider}`);
      
      this.updateShareInteraction(this.containerContent, this.content, this.shareInteraction, provider, this.sharePath, this.isIframe, this.canUseWebShare);
    }
  },
  computed: {
    canUseWebShare() {
      return "share" in navigator;
    },
    shareInteraction() {
      return this.content.share?.interaction ?? {}
    },
    shareProviders() {
      return (this.content.share?.providers ?? "").split(",");
    }
  }
}
</script>

<style lang="scss" scoped>
[modal-share-component] {
  .share-all-icon {
    border-radius: 6px;
    width: 2.5rem;
    height: 2.5rem;
    color: $gray-600;

    i {
      &:hover,
      &:active,
      &:focus {
        font-weight: 900;
      }
    }
  }

  .share-modal {
    background-color: rgba(0, 0, 0, 0.8);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: $zindex-sticky;

    &__content {
      width: 50vh;
      background: $white;

      .share-link {
        transition: color $animation-time-fast;

        &:hover,
        &:active,
        &:focus {
          color: $gray-700;
        }
      }

      .fa-lg {
        @include font-size(1.125rem);
      }
    }
  }
}
</style>